<template lang="pug">
  v-dialog(v-model="dialogContactUs" fullscreen hide-overlay transition='dialog-bottom-transition')
    v-card
      v-card-text#header-inside-contact-us
        v-layout(class="header" row wrap)
          v-flex.container--logo(xs6 sm6 md4 lg4)
            router-link(target="_self" :to="'/inicio'")
              img(src="@/assets/logo.svg" srcset="@/assets/logo.svg" alt="Logo")
          v-flex.container--logout(xs6 sm6 md6 lg6)
            a.logout.omnesRegular(href="#" v-on:click="logout($event)") Cerrar Sesión
        v-layout(row wrap)
          v-flex.title-insurances(xs12)
            img(:src='iconProduct' width="35%")
            h1 CONTÁCTANOS
            v-btn#btn__close(icon dark @click.native="hideDialog()")
              v-icon close
          v-flex(xs12)
            .text-desc
              p
                | Conoce los canales de
                br
                | atención que tenemos para ti.
            .btns-contact
              v-btn(round @click="openNewWindow('https://www.interseguro.pe/ayuda/escribenos')")
                img(:src="iconEmailus")
                | Escríbenos
              br
              v-btn(round @click="openNewWindow('https://www.interseguro.pe/ayuda/contactanos')")
                img(:src="iconGeolocation")
                | Nuestras oficinas
</template>

<script>
export default {
  props: ['dialogContactUs'],
  data () {
    return {
      iconProduct: require('./../../assets/icons/icon-section-contactanos.svg'),
      iconEmailus: require('./../../assets/icons/icon-section-contact-correo.svg'),
      iconGeolocation: require('./../../assets/icons/icon-section-contact-ubicacion.svg')
    }
  },
  methods: {
    hideDialog () {
      document.body.removeAttribute('class', 'noscroll')
      this.$root.$emit('closecontactUs', {})
    },
    openNewWindow (url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style>
  .text-desc p {
    font-size: 18px;
    text-align: center;
    margin-top: 11px;
  }
  .btns-contact {
    text-align: center;
    margin-bottom: 1.3em;
  }
  .btns-contact button {
    background-color: #0855C4 !important;
    border-color: #0855C4 !important;
    max-width: 195px;
    height: 45px;
  }
  .btns-contact button .v-btn__content img {
    width: 17%;
    background-color: #FFF;
    border-radius: 20px;
    margin-right: 9px;
  }
  .btns-contact button .v-btn__content {
    color: #FFF;
    width: 100%;
    justify-content: left;
    text-transform: initial;
    font-size: 16px;
  }
  #header-inside-contact-us .layout.header {
    background-color: #0855C4;
    padding: 1.3em 16px 0.7em 16px;
  }
  #header-inside-contact-us .layout.header .flex.container--logout {
    padding-top: 6px;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/DialogContactUs.vue